import { render, staticRenderFns } from "./SafetyMemo.vue?vue&type=template&id=6fe7aa7e&scoped=true&"
import script from "./SafetyMemo.vue?vue&type=script&lang=ts&"
export * from "./SafetyMemo.vue?vue&type=script&lang=ts&"
import style0 from "./SafetyMemo.vue?vue&type=style&index=0&id=6fe7aa7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7aa7e",
  null
  
)

export default component.exports